import BaseModel from '../../../model/BaseModel';
import { BloodPressure } from '../../../model/BloodPressure';
import Feature from '../../../strategy/Feature';

export default class MockBloodPressureFeature implements Feature {
  execute(): BaseModel {
    const min = Math.ceil(80);
    const max = Math.floor(120);
    return new BloodPressure(
      Math.floor(Math.random() * (max - min)) + min,
      Math.floor(Math.random() * (max - min)) + min
    );
  }
}
